import { NodeTypes } from "@/workflow_api/types/workflow";

export const NODE_TYPE_TO_API_MAPPING: Record<string, string> = {
  [NodeTypes.IF]: "IF_CONDITION",
  [NodeTypes.SWITCH]: "SWITCH_CONDITION",
  [NodeTypes.MULTITHREAD]: "MULTITHREAD",
  [NodeTypes.WAIT]: "WAIT",
  [NodeTypes.MERGE]: "MERGE",
  [NodeTypes.ASSIGN_GROUP]: "GENERAL",
  [NodeTypes.NOTIFICATION]: "NOTIFICATION",
  [NodeTypes.EXPEDIENTE]: "EXPEDIENT",
  [NodeTypes.CALCULATED]: "GENERAL",
  [NodeTypes.PAYMENT]: "PAYMENT",
  [NodeTypes.N8N]: "N8N",
  [NodeTypes.INTEROPERABILITY]: "INTEROPERABILITY",
  [NodeTypes.DOC_GENERATOR]: "DOCUMENT_GENERATOR",
  [NodeTypes.SIGN_DOCUMENT]: "SIGN_DOCUMENT",
  [NodeTypes.RESOLUTION]: "RESOLUTION",
  [NodeTypes.DATA_CENTER]: "DATA_CENTER",
  [NodeTypes.CORRECTION]: "REVISION",
  [NodeTypes.FORM]: "FORM",
  [NodeTypes.INITIALIZER]: "GENERAL",
  [NodeTypes.END]: "GENERAL",
} as const;

// Mapeo de NodeTypes a ref_name correctos
export const NODE_TYPE_TO_REF_NAME_MAPPING: Record<string, string> = {
  [NodeTypes.IF]: "if-node",
  [NodeTypes.SWITCH]: "switch-node",
  [NodeTypes.MULTITHREAD]: "multithread-node",
  [NodeTypes.WAIT]: "wait-node",
  [NodeTypes.MERGE]: "merge-node",
  [NodeTypes.ASSIGN_GROUP]: "assign-group-node",
  [NodeTypes.NOTIFICATION]: "notification-node",
  [NodeTypes.EXPEDIENTE]: "expedient-node",
  [NodeTypes.CALCULATED]: "calculated-node",
  [NodeTypes.PAYMENT]: "payment-node",
  [NodeTypes.N8N]: "n8n-node",
  [NodeTypes.INTEROPERABILITY]: "interoperability-node",
  [NodeTypes.DOC_GENERATOR]: "document-generator-node",
  [NodeTypes.SIGN_DOCUMENT]: "sign-document-node",
  [NodeTypes.RESOLUTION]: "resolution-node",
  [NodeTypes.DATA_CENTER]: "data-center-node",
  [NodeTypes.CORRECTION]: "revision-node",
  [NodeTypes.FORM]: "form-node",
  [NodeTypes.INITIALIZER]: "initializer-node",
  [NodeTypes.END]: "finish-node",
} as const;

export const mapNodeTypeToApi = (nodeType: string): string => {
  return NODE_TYPE_TO_API_MAPPING[nodeType] || nodeType;
};

export const mapApiToNodeType = (apiType: string): string => {
  const entry = Object.entries(NODE_TYPE_TO_API_MAPPING).find(
    ([, value]) => value === apiType,
  );
  return entry ? entry[0] : apiType;
};

export const mapNodeTypeToRefName = (nodeType: string): string => {
  return NODE_TYPE_TO_REF_NAME_MAPPING[nodeType] || nodeType;
};

export const mapRefNameToNodeType = (refName: string): string => {
  const entry = Object.entries(NODE_TYPE_TO_REF_NAME_MAPPING).find(
    ([, value]) => value === refName,
  );
  return entry ? entry[0] : refName;
};

export const VALID_MERGE_API_TYPES = [
  "GENERAL",
  "IF_CONDITION",
  "FORM",
  "SWITCH_CONDITION",
  "MULTITHREAD",
  "WAIT",
  "WEBHOOK",
  "REVISION",
  "DOCUMENT_GENERATOR",
  "SIGN_DOCUMENT",
  "INTEROPERABILITY",
  "DATA_CENTER",
  "NOTIFICATION",
  "PAYMENT",
  "RESOLUTION",
  "EXPEDIENT",
  "N8N",
  "MERGE",
] as const;
